import {fetchGet, fetchPost, fetchPatch} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const getVenueDancerEdit = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/dancer/edit",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const addDancerToVenueById = (
    venueId,
    venueAdd,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = venueAdd;
    fetchPost(
        uri + "/venue/" + venueId + "/dancer/add",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};

export const updateVenueDancerById = (
    venueId,
    venueUpdate,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = venueUpdate;
    fetchPatch(
        uri + "/venue/" + venueId + "/dancer/update",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};

export const deleteDancerFromVenueById = (
    venueId,
    venueDelete,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = venueDelete;
    fetchPost(
        uri + "/venue/" + venueId + "/dancer/delete",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};